<!-- 采购结算申请数据操作 -->
<template>
  <div>
    <div>
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-form @submit.native.prevent class="baseForm" :show-message="false" id="mainInfo" label-width="100px" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                    <el-row v-if="dataActionBox.actionType != 2" ref="baseForm">
                      <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                        <el-date-picker v-if="formOneValue.fieldType == 'date'" size="mini" v-model="sendDataInfo[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"
                          :clearable="false" :editable="false" :isdisabled="formOneValue.isChange == 0"></el-date-picker>
                          <el-tooltip v-else-if="formOneValue.fieldType == 'search' && formOneValue.entityField == 'record'" class="item" :disabled="sendDataInfo.octId==null||sendDataInfo.octId==''?true:false || sendDataInfo.octId.length<=9" effect="dark"
        :content="sendDataInfo.octId" placement="bottom-start">
                          <el-input v-if="formOneValue.fieldType == 'search' && formOneValue.entityField == 'record'" :disabled="formOneValue.isChange == 0" clearable @keyup.enter.native="extract('sendDataInfo', 1)"
                          v-model.trim="sendDataInfo.octId" :maxlength="$store.state.inputLength">
                          <el-button @click="extract('sendDataInfo', 1)" slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                          </el-button>
                        </el-input>
                        </el-tooltip>
                        <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                        <el-input  clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                          </el-button>
                        </el-input>
                        </el-tooltip>
                        <el-input v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType == 2" ref="baseForm">
                      <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <span v-if="formOneValue.fieldType == 'date'&&sendDataInfo[formOneValue.entityField]">
                          {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                        </span>
                        <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                  <!-- 明细信息 -->
                  <div>
                    <el-form @submit.native.prevent :inline="true" size="mini" style="display:flex;">
                      <div style="width:100%">
                        <div style="display:flex;justify-content: space-between;width:100%;" id="operateBtn">
                          <div v-if="dataActionBox.actionType == 0">
                            <el-button @click="extract('sendDataInfo', 2)" type="primary" size="mini" style="margin-bottom:2px;">提取单据</el-button>
                            <el-button :disabled="sendDataInfo.desynAcceptsettlementdetails.length < 1" @click="deleteDetails(2)" type="danger" size="mini" style="margin-bottom:2px;">删除</el-button>
                          </div>
                          <el-tag style="margin-right:10px;font-size:16px;margin-bottom:2px;" type="warning">付款总金额:{{ fkTotalMoney }}</el-tag>
                        </div>
                        <el-table size="mini" ref="mxTableRef2" :rosw-class-name="rowClassName2" :row-style="rowStyle" @row-click="clickEvent2" @selection-change="handleSelectionChange2" :data="sendDataInfo.desynAcceptsettlementdetails"
                          border style="width: 100%" :height="mxHeight">
                          <el-table-column label="选择操作" width="90" v-if="dataActionBox.actionType == 0">
                            <template slot-scope="scope">
                              <el-radio v-model="selectedDataIndex1" :label="scope.$index" border size="mini">
                                <i class="el-icon-thumb"></i>
                              </el-radio>
                            </template>
                          </el-table-column>
                          <el-table-column show-overflow-tooltip :min-width="formOneValue.fieldWeight" :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey"
                            v-if="formOneValue.isShow == 1">
                            <template slot-scope="scope">
                              <input class="newInput" @input="toMoney(scope.$index)" :ref="formOneValue.entityField" @keyup.enter="tableNextFocus2(formOneValue.focusField, scope.$index)"
                                v-if="formOneValue.entityField == 'settleMoney' && dataActionBox.actionType != 2" :min="scope.row.oldBalance > 0 ? 0 : scope.row.oldBalance" :max="scope.row.oldBalance > 0 ? scope.row.oldBalance : 0"
                                type="number" v-model.trim="sendDataInfo.desynAcceptsettlementdetails[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength" />
                              <span v-else>{{sendDataInfo.desynAcceptsettlementdetails[scope.$index][formOneValue.entityField]}}</span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foot">
          <div>
            <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
            <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType == 2">关闭</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
          </div>
          <!-- <el-form @submit.native.prevent :inline="true" :model="sendDataInfo" class="demo-form-inline ml"
                        v-if="footForm">
                        <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                            <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                        </el-form-item>
                    </el-form> -->
        </div>
      </div>
    </div>

    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>

    <el-dialog :title="seTitle" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchSchemeMultipleSubScrip ref="searchSchemeMultiple" :id="searchId" :parentSearchData="parentSearchData1" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="getSelect">确认选择</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="seTitle" v-if="DialogVisible2" :visible.sync="DialogVisible2" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchSchemeMultiple ref="searchSchemeMultiple2" :id="searchId" :parentData="parentData" :parentSearchData="sendDataInfo" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="getSelect">确认选择</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "@/byComponents/SearchScheme.vue";
import SearchSchemeMultiple from "@/byComponents/SearchSchemeMultiple.vue";
import SearchSchemeMultipleSubScrip from "@/byComponents/SearchSchemeMultipleSubScrip.vue";
export default {
  name: 'subscriptionSettleAction',
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    SearchSchemeMultiple,
    SearchSchemeMultipleSubScrip,
  },
  data() {
    //这里存放数据
    return {
      selectDataTable: false,
      dataActionBox: {
        showStatus: false,
        openMode: 'ltr' || 'rtl',
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      detaislDataInfo: {},
      selectedDataIndex: 0,
      selectedDataIndex1: 0,
      tableType: 1,
      sendDataInfo: {
        "desynAcceptdetails": [], //认款记录
        "desynAcceptsettlementdetails": [], //单据
        "cmId": '',
        "cmName": '',
        "opmId": 0,
        "opmName": '',
        "salesId": "",
        "salesName": "",
        "totalCount": 0,
        "totalMoney": 0,
        "totalNumber": 0,
        "depId": "",
        "depName": "",
        "coId": '',
        "coName": '',
        settleMode: '',
        payMethod: '',
        noorderPrepaySum: '',
        payMoney: 0,
        //
        "psmoney": "",
        "repsmoney": "",
        "unpsmoney": "",
        "octId": "",
        "coId": "",
        "cmId": "",
        "opmId": "",
        "salesId ": "",
        "unsettlement": ""
      },
      showTabs: '',
      formDataList: [],
      goodsList: [],
      detailsBox: {
        status: false,
        type: 0,
        title: "新增" || "修改",
      },
      editDateilsIndex: "",
      exId: "",
      seId: "",
      ceshi: "",
      dialogTitle: "",
      seWidth: "",
      height: "",
      exTitle: "",
      seTitle: "",
      seWidth: "",
      exWidth: "",
      DialogVisible: false,
      DialogVisible1: false,
      DialogVisible2: false,
      DialogExtract: false,
      newFormDataList: [],
      seType: '',
      cmId: '',
      parentSearchData: {
        cmId: ''
      },
      parentSearchData1: {
        cmId: '',
        coId: '',
        opmId: '',
        salesId: '',
        depId: ''
      },
      searchId: '',
      mxHeight: 0,
      isBuyer: 0,
      tabForm: [],
      mxForm: [],
      djForm: [],
      footForm: [],
      nosField: '',
      sField: '',
      fField: '',
      selectedRow: [], // 当前已选择行
      selectedRow2: [], // 当前已选择行
      fkTotalMoney: 0,
      rkTotalMoney: 0,
      parentData: {
        type: "dasmId",
        list: []
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    // "sendDataInfo.desynAcceptdetails": {
    //     handler: function (newValue, oldValue) {
    // if (this.dataActionBox.actionType == 0) {
    //     this.sendDataInfo.totalMoney = 0;
    //     newValue?.forEach((item, keys) => {
    //         this.sendDataInfo.totalMoney = this.toFixed2(
    //             NP.plus(this.sendDataInfo.totalMoney, item.psmoney), 2
    //         );
    //     });
    // }
    //     },
    //     deep: true,
    // },
    "sendDataInfo.desynAcceptsettlementdetails": {
      handler: function (newValue, oldValue) {
        this.fkTotalMoney = 0;
        newValue.forEach((item, keys) => {
          this.fkTotalMoney = this.$common.getDecimalInfo(3,
            NP.plus(this.fkTotalMoney, item.settleMoney)
          );
          // this.fkTotalMoney = this.toFixed2(
          //   NP.plus(this.fkTotalMoney, item.settleMoney), 2
          // );
        });
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    // 重写
    // toFixed2(number, decimal) {
    //   decimal = decimal || 0;
    //   var s = String(number);
    //   var decimalIndex = s.indexOf('.');
    //   if (decimalIndex < 0) {
    //     var fraction = '';
    //     for (var i = 0; i < decimal; i++) {
    //       fraction += '0';
    //     }
    //     return s + '.' + fraction;
    //   }
    //   var numDigits = s.length - 1 - decimalIndex;
    //   if (numDigits <= decimal) {
    //     var fraction = '';
    //     for (var i = 0; i < decimal - numDigits; i++) {
    //       fraction += '0';
    //     }
    //     return s + fraction;
    //   }
    //   var digits = s.split('');
    //   var pos = decimalIndex + decimal;
    //   var roundDigit = digits[pos + 1];
    //   if (roundDigit > 4) {
    //     //跳过小数点
    //     if (pos == decimalIndex) {
    //       --pos;
    //     }
    //     digits[pos] = Number(digits[pos] || 0) + 1;
    //     //循环进位
    //     while (digits[pos] == 10) {
    //       digits[pos] = 0;
    //       --pos;
    //       if (pos == decimalIndex) {
    //         --pos;
    //       }
    //       digits[pos] = Number(digits[pos] || 0) + 1;
    //     }
    //   }
    //   //避免包含末尾的.符号
    //   if (decimal == 0) {
    //     decimal--;
    //   }
    //   return digits.slice(0, decimalIndex + decimal + 1).join('');
    // },
    // 子组件穿透方法
    toDetail(orderId) {
      if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
      else this.$parent.$parent.$parent.toDetail(orderId)
    },
    calculateTotal(e) {
      if (this.tableType == 0 || e == 0) {
        addEventListener('keyup', this.keyUp1) //创建监听键盘事件
        removeEventListener('keyup', this.keyUp2)
        this.sendDataInfo.totalMoney = 0
        this.sendDataInfo.totalCount = this.sendDataInfo.desynAcceptdetails.length
        if (this.sendDataInfo.desynAcceptdetails.length > 0) {
          this.sendDataInfo.desynAcceptdetails.forEach(item => {
            if (item.oldBalance > 0) {
              if (item.settleMoney > item.oldBalance) {
                item.settleMoney = item.oldBalance
              } else if (item.settleMoney < 0) {
                item.settleMoney = 0
              }
            } else if (item.oldBalance < 0) {
              if (item.settleMoney < item.oldBalance) {
                item.settleMoney = item.oldBalance
              } else if (item.settleMoney > 0) {
                item.settleMoney = 0
              }
            }
            this.sendDataInfo.totalMoney = NP.plus(this.sendDataInfo.totalMoney, Number(item.settleMoney));
          })
        }
      } else if (this.tableType == 1 || e == 1) {
        addEventListener('keyup', this.keyUp2) //创建监听键盘事件
        removeEventListener('keyup', this.keyUp1)
        this.sendDataInfo.totalMoney = 0
        this.sendDataInfo.totalCount = this.sendDataInfo.desynAcceptsettlementdetails.length
        if (this.sendDataInfo.desynAcceptsettlementdetails.length > 0) {
          this.sendDataInfo.desynAcceptsettlementdetails.forEach(item => {
            // if (item.settleCount == '' || !item.settleCount) {
            //     item.settleCount = 0
            //     item.settleMoney = 0
            // }
            item.settleMoney = NP.times(item.psprice, item.settleCount);
            if (item.oldBalance > 0) {
              if (item.settleMoney > item.oldBalance) {
                item.settleMoney = item.oldBalance
                item.settleCount = item.settleMoney / Number(item.psprice)
              } else if (item.settleMoney < 0) {
                item.settleMoney = 0
                item.settleCount = 0
              }
            } else if (item.oldBalance < 0) {
              if (item.settleMoney < item.oldBalance) {
                item.settleMoney = item.oldBalance
                item.settleCount = item.settleMoney / Number(item.psprice)
              } else if (item.settleMoney > 0) {
                item.settleMoney = 0
                item.settleCount = 0
              }
            }
            this.sendDataInfo.totalMoney = NP.plus(this.sendDataInfo.totalMoney, Number(item.settleMoney));
          })
          this.sendDataInfo.desynAcceptsettlementdetails.splice(1, 0)
        }
      }
    },
    toMoney(index) {
      if (this.sendDataInfo.desynAcceptsettlementdetails[index].settleMoney > this.sendDataInfo.desynAcceptsettlementdetails[index].oldBalance) {
        this.sendDataInfo.desynAcceptsettlementdetails[index].settleMoney = this.sendDataInfo.desynAcceptsettlementdetails[index].oldBalance
      } else if (this.sendDataInfo.desynAcceptsettlementdetails[index].settleMoney < 0) {
        this.sendDataInfo.desynAcceptsettlementdetails[index].settleMoney = 0
      }
      this.$forceUpdate()
      this.fkTotalMoney = 0
      this.sendDataInfo.desynAcceptsettlementdetails.forEach(item => {
        this.fkTotalMoney = NP.plus(this.fkTotalMoney, Number(item.settleMoney))
      })
    },
    getSelect() {
      if (this.tableType == 1) {
        let mx = this.$refs.searchSchemeMultiple.multipleSelection[0]
        this.sendDataInfo.desynAcceptdetails = mx
        this.$nextTick(() => {
          for (let key in mx) {
            if (Object.hasOwnProperty.call(this.sendDataInfo, key)) {
              this.sendDataInfo[key] = mx[key];
            }
          }
        })
        this.DialogVisible1 = false
      } else if (this.tableType == 2) {
        let mx = this.$refs.searchSchemeMultiple2.multipleSelection
        this.sendDataInfo.desynAcceptsettlementdetails = mx
        this.sendDataInfo.desynAcceptsettlementdetails.forEach(item => {
          item.settleMoney = ''
          this.$set(item, 'settleMoney', item.oldBalance)
        })
        this.DialogVisible2 = false
      }

    },
    extract(sendDataInfo, type) {
      this.tableType = type
      removeEventListener('keyup', this.keyUp1)
      removeEventListener('keyup', this.keyUp2)
      this.$refs[sendDataInfo].validate((valid) => {
        // if (valid) {
        if (type == 1) {
          this.searchId = '122082429079552'
          this.DialogVisible1 = true
        } else if (type == 2) {
          this.searchId = '779666991583232'
          if (this.sendDataInfo.desynAcceptsettlementdetails.length > 0) {
            this.parentData.list = this.sendDataInfo.desynAcceptsettlementdetails
          }
          this.DialogVisible2 = true
        }

        // this.$nextTick(()=>{
        //     this.$refs.searchSchemeMultiple.openKeyup()
        // })
        // } else {
        //     this.$message({
        //         message: '请完善必填项~',
        //         type: "warning"
        //     })
        // }
      })
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        addEventListener('keyup', this.keyUp1) //创建监听键盘事件
        addEventListener('keyup', this.keyUp2) //创建监听键盘事件
        this.paramValue(val)
        if (this.seType == 'cmName') {
          if (this.sendDataInfo.cmName != val.cmName) {
            this.sendDataInfo.salesName = ''
            this.sendDataInfo.salesId = ''
            this.parentSearchData1.salesId = ''
          }
          this.parentSearchData.cmId = val.cmId
          this.parentSearchData1.cmId = val.cmId
        } else if (this.seType == 'salesName') {
          this.parentSearchData1.salesId = val.salesId
        } else if (this.seType == 'opmName') {
          this.parentSearchData1.opmId = val.opmId
        } else if (this.seType == 'coName') {
          this.parentSearchData1.coId = val.coId
        } else if (this.seType == 'depName') {
          this.parentSearchData1.depId = val.depId
        }
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= (this.inputel.length - 1)) {
        this.$nextTick(() => {
          // this.extract('sendDataInfo',1)
        })
        return
      }
      var aindex = index + 1
      if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
        this.nextFocus(aindex)
        return
      }
      this.inputel[aindex].focus()
    },
    // 表格切换焦点方法
    tableNextFocus2(field, index) {
      if (field == '') return
      if (field == 'keydown') {
        if (index == this.sendDataInfo.desynAcceptsettlementdetails.length - 1) return
        if (this.sendDataInfo.desynAcceptsettlementdetails[index + 1] != undefined) {
          this.selectedDataIndex1 = index + 1
          this.$nextTick(() => {
            let refsElTable = this.$refs.mxTableRef2
            this.$refs['settleMoney'][index + 1].focus() //跳退货数量
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptsettlementdetails[this
              .selectedDataIndex1]);
          })
          return
        }
      }
      this.$refs[field][index].focus()
    },
    // 表格切换焦点方法
    tableNextFocus1(field, index) {
      if (field == '') return
      if (field == 'keydown') {
        if (index == this.sendDataInfo.desynAcceptdetails.length - 1) return
        if (this.sendDataInfo.desynAcceptdetails[index + 1] != undefined) {
          this.selectedDataIndex = index + 1
          this.$nextTick(() => {
            let refsElTable = this.$refs.mxTableRef1
            this.$refs['settleMoney'][index + 1].focus() //跳退货数量
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptdetails[this
              .selectedDataIndex]);
          })
          return
        }
      }
      this.$refs[field][index].focus()
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById('mainInfo')
      if (el) this.inputel = el.getElementsByTagName('input')
    },
    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == '') {
          this.inputel[index].focus()
          break
        }
      }
    },
    // 检索Id, 索引(表格中), 标识
    //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
    openSearch(sId, index, type, sField, fField, nosField) {
      if (type == 'salesName' || type == 'sbiAddress') {
        if (this.parentSearchData.cmId == '') {
          return this.$message({
            message: '请先选择客户',
            type: 'warning'
          });
        }
      }
      this.DialogVisible = true;
      removeEventListener('keyup', this.keyUp1)
      removeEventListener('keyup', this.keyUp2)
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField
      this.fField = fField
      this.nosField = nosField
      this.parentSearchData[type] = this.sendDataInfo[type]
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
      console.log(this.sendDataInfo)
      this.$nextTick(() => {
        this.nextFocus(this.seIndex)
      })
    },
    tableRowClassName({
      row,
      rowIndex
    }) {
      row.index = rowIndex;
    },
    detailsAction(cate = 0) {
      if (cate == 0) {
        this.editDateilsIndex = ""
        return false
      }

      var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo))
      if (dataInfo.psodPacknum <= 0) {
        this.$message({
          message: '请填写采购数量',
          type: 'error'
        });
        return false
      }
      if (this.editDateilsIndex !== "") {
        this.sendDataInfo.pisOrderDetail.splice(this.editDateilsIndex, 1)
      }
      this.sendDataInfo.pisOrderDetail.push(dataInfo)
      // console.log('this.sendDataInfo.pisOrderDetail',this.sendDataInfo.pisOrderDetail)
      this.editDateilsIndex = ""
      this.detailsBox.status = false
    },
    initActionBox(sendDataInfo) {
      if (this.dataActionBox.actionType == 2) return this.$emit('drawerCancel');
      this.$confirm('确定取消新增吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('drawerCancel')
        this.init()
        this.$refs.sendDataInfo.resetFields();
      }).catch(() => { });

    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == 'pisOrderAuxinf') {
          for (let sonOne in this.sendDataInfo[key]) {
            this.sendDataInfo[key][sonOne] = ''
          }
        } else {
          this.sendDataInfo[key] = ''
        }
      }
      this.sendDataInfo.dpsmDate = new Date().getTime();
      this.sendDataInfo.desynAcceptsettlementdetails = []
      this.sendDataInfo.desynAcceptdetails = []
      this.sendDataInfo.isWms = 0
      this.sendDataInfo.preMoney = 0
      this.sendDataInfo.totalMoney = 0
      this.sendDataInfo.totalNumber = 0
      this.sendDataInfo.totalCount = 0
    },

    selectDataAction(data) {
      this.detaislDataInfo = {
        // "bgmId":data.bgmId,
        "bgmId": data.bgmId,
        "bgmName": data.bgmName,
        "inRate": data.bgfIntaxrate,
        bgmManufacturer: data.bgmManufacturer,
        bgmSpecifications: data.bgmSpecifications,
        bgmPlaceorigin: data.bgmPlaceorigin,
        "money": 0,
        "psodPacknum": 0,
        "price": 0,
        "psodPsdvolume": 0,
        "psodPslowerlimit": 0,
        "psmoney": 0,
        "psodPsnvolume": 0,
        "psprice": 0,
        "psodPsupperlimit": 0,
        "pspmId": '',
        "stId": data.stId,
        "pspdId": '',
        "psodReserves1": "",
        "psodReserves2": "",
        "psodReserves3": "",
        "psodReserves4": "",
        "psodReserves5": "",
        "psodReserves6": "",
      }
      this.selectDataTable = false
    },

    openBox() {
      this.dataActionBox.actionType = this.actionData.cate
      this.formDataList = JSON.parse(JSON.stringify(this.actionData.formData))
      var oldData = this.actionData.oldData
      this.showTabs = this.actionData.formData[0].jciName
      this.filterMainField()
      this.init()
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = '新增信息'
        this.dataActionBox.openMode = 'ltr'
        for (let key in this.parentSearchData) {
          this.parentSearchData[key] = ''
        }
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = '编辑信息'
        this.dataActionBox.openMode = 'rtl'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
        this.tableType = this.sendDataInfo.settleMode
        this.cmId = dataInfo.cmId
      } else {
        this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
        this.tableType = this.sendDataInfo.settleMode
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.mxHeight = this.$common.getBtnHeight()
          this.initFocus();
        }, 16.7)
      })

    },
    sendDataAction(sendDataInfo) {
      // this.$refs[sendDataInfo][0].validate((valid) => {
      //     if (valid) {
      //         if (this.sendDataInfo.totalMoney != this.fkTotalMoney) {
      //             return this.$message({
      //                 message: '认款金额须等于付款金额',
      //                 type: "warning"
      //             })
      //         }
      this.sub(sendDataInfo)
      //     } else {
      //         console.log('error submit!!');
      //         return false;
      //     }
      // })
    },
    async sub(sendDataInfo) {
      if (this.sendDataInfo.desynAcceptsettlementdetails.length < 1) {
        return this.$message({
          type: "error",
          message: "单据不能为空",
        });
      }
      if (this.sendDataInfo.desynAcceptdetails.length < 1) {
        return this.$message({
          type: "error",
          message: "认款记录不能为空",
        });
      }
      if (this.sendDataInfo.desynAcceptsettlementdetails.some((val) => val.settleMoney == 0 || val.settleMoney == '')) {
        this.$message({
          type: "error",
          message: "单据付款金额不能为0或者空",
        });
        return;
      }
      var sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
      // var data1 = []
      // this.sendDataInfo.desynAcceptdetails.forEach(item => {
      //     data1.push({
      //         octId: item.octId
      //     })
      // })
      // sendData.desynAcceptdetails = data1
      var data2 = []
      this.sendDataInfo.desynAcceptsettlementdetails.forEach(item => {
        data2.push({
          dasmId: item.dasmId,
          settleMoney: item.settleMoney,
        })
      })
      sendData.desynAcceptsettlementdetails = data2
      var responseData = await this.$http.addAcceptsettlement(sendData)
      if (responseData.status == 200) {
        this.init()
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.$emit('drawerCancel')
        this.$refs.sendDataInfo.resetFields();

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    deleteDetails(type) {
      this.tableType = type
      if (this.tableType == 1) {
        this.sendDataInfo.desynAcceptdetails.splice(this.selectedDataIndex, 1)
        this.selectedDataIndex = 0
      } else if (this.tableType == 2) {
        this.sendDataInfo.desynAcceptsettlementdetails.splice(this.selectedDataIndex1, 1)
        this.selectedDataIndex1 = 0
      }
    },

    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = [];
      var mxFormList = [];
      this.formDataList.forEach((item) => {
        if (item.jciType == 1) {
          mainFormList.push(item);
        } else if (item.jciType == 2) {
          mxFormList.push(item);
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
        }
      });
      this.djForm = mxFormList[0].jurconfigform;
      this.mxForm = mxFormList[1].jurconfigform;
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key));
        this.tabForm[i].jurconfigform = [];
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1)
            this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
        }
      });
      var arr = [{ entityField: "desynAcceptsettlementdetails" }, { entityField: "desynAcceptdetails" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {
        this.$set(this.sendDataInfo, key, obj[key])
      }
      this.$set(this.sendDataInfo, "isWms", 0)
      this.$set(this.sendDataInfo, "preMoney", 0)
      this.$set(this.sendDataInfo, "dpsmDate", new Date().getTime())
    },
    // 监听键盘事件
    keyUp1(e) {
      if (e.key == 'F1') { // 右键新增明细
        e.preventDefault();
        // this.addDetail('sendDataInfo')
        return
      } else if (e.key == 'F2') {
        e.preventDefault();
        this.deleteDetails()
      } else if (e.keyCode == 40) { // 下键
        // 表格为空，不执行下方 
        if (this.sendDataInfo.desynAcceptdetails.length == 0) return
        let refsElTable = this.$refs.mxTableRef1
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
            this.selectedDataIndex = 0
          } else if (this.selectedDataIndex == this.sendDataInfo.desynAcceptdetails.length -
            1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
            this.selectedDataIndex = 0
          } else { // 正常递增
            this.selectedDataIndex++
          }
          if (!refsElTable) return
          let findRow = this.selectedRow.find(c => c.rowIndex == this
            .selectedDataIndex); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptdetails[this
              .selectedDataIndex], false);
            return;
          }
          // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptdetails[this
            .selectedDataIndex]); // 把现在当前行勾选
        })
      } else if (e.keyCode == 38) { // 上键
        if (this.sendDataInfo.desynAcceptdetails.length == 0) return
        let refsElTable = this.$refs.mxTableRef1
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
            this.selectedDataIndex = 0
          } else if (this.selectedDataIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
            this.selectedDataIndex = this.sendDataInfo.desynAcceptdetails.length - 1
          } else { // 正常递减
            this.selectedDataIndex--
          }
          if (!refsElTable) return
          let findRow = this.selectedRow.find(c => c.rowIndex == this
            .selectedDataIndex); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptdetails[this
              .selectedDataIndex], false);
            return;
          }
          // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptdetails[this
            .selectedDataIndex]); // 把现在当前行勾选
        })
      }

    },
    closeChild() {
      addEventListener('keyup', this.keyUp1) //创建监听键盘事件
    },
    // 表格方法
    rowClassName1({
      row,
      rowIndex
    }) {
      let rowName = "",
        findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },

    // 选中行底色逻辑
    rowStyle({
      row,
      rowIndex
    }) {
      Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false
      });
    },

    // 明细表格点击选中
    clickEvent1(row, column, event, params) {
      let refsElTable = this.$refs.mxTableRef1; // 获取表格对象
      let findRow = {}
      this.selectedDataIndex = row.rowIndex
      findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.selectedRow.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
    },

    // 保存已选择行
    handleSelectionChange1(rows) {
      this.selectedRow = rows; // 保存已选择行
    },

    // 监听键盘事件
    keyUp2(e) {
      if (e.key == 'F1') { // 右键新增明细
        e.preventDefault();
        // this.addDetail('sendDataInfo')
        return
      } else if (e.key == 'F2') {
        e.preventDefault();
        // this.deleteDetails()
      } else if (e.keyCode == 40) { // 下键
        // 表格为空，不执行下方 
        if (this.sendDataInfo.desynAcceptsettlementdetails.length == 0) return
        let refsElTable = this.$refs.mxTableRef2
        this.$nextTick(() => {
          if (this.selectedRow2.length == 0) { // 如果当前没有选中行，则直接选中第一个
            this.selectedDataIndex1 = 0
          } else if (this.selectedDataIndex1 == this.sendDataInfo.desynAcceptsettlementdetails.length -
            1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
            this.selectedDataIndex1 = 0
          } else { // 正常递增
            this.selectedDataIndex1++
          }
          if (!refsElTable) return
          let findRow = this.selectedRow2.find(c => c.rowIndex == this
            .selectedDataIndex1); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow2.length === 1) {
            refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptsettlementdetails[this
              .selectedDataIndex1], false);
            return;
          }
          // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptsettlementdetails[this
            .selectedDataIndex1]); // 把现在当前行勾选
        })
      } else if (e.keyCode == 38) { // 上键
        if (this.sendDataInfo.desynAcceptsettlementdetails.length == 0) return
        let refsElTable = this.$refs.mxTableRef2
        this.$nextTick(() => {
          if (this.selectedRow2.length == 0) { // 当前没有选中行，则直接选中第一个
            this.selectedDataIndex1 = 0
          } else if (this.selectedDataIndex1 == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
            this.selectedDataIndex1 = this.sendDataInfo.desynAcceptsettlementdetails.length - 1
          } else { // 正常递减
            this.selectedDataIndex1--
          }
          if (!refsElTable) return
          let findRow = this.selectedRow2.find(c => c.rowIndex == this
            .selectedDataIndex1); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow2.length === 1) {
            refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptsettlementdetails[this
              .selectedDataIndex1], false);
            return;
          }
          // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(this.sendDataInfo.desynAcceptsettlementdetails[this
            .selectedDataIndex1]); // 把现在当前行勾选
        })
      }

    },
    closeChild() {
      addEventListener('keyup', this.keyUp) //创建监听键盘事件
    },
    // 表格方法
    rowClassName2({
      row,
      rowIndex
    }) {
      let rowName = "",
        findRow = this.selectedRow2.find(c => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },

    // 选中行底色逻辑
    rowStyle({
      row,
      rowIndex
    }) {
      Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false
      });
    },

    // 明细表格点击选中
    clickEvent2(row, column, event, params) {
      let refsElTable = this.$refs.mxTableRef2; // 获取表格对象
      let findRow = {}
      this.selectedDataIndex1 = row.rowIndex
      findRow = this.selectedRow2.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.selectedRow2.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
    },

    // 保存已选择行
    handleSelectionChange2(rows) {
      this.selectedRow2 = rows; // 保存已选择行
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox()
    })
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    addEventListener('keyup', this.keyUp1) //创建监听键盘事件
  },
  beforeDestroy() {
    removeEventListener('keyup', this.keyUp1)
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput()
  }, //生命周期 - 更新之后
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.flex {
  display: flex;
  align-items: center;
}

.newInput {
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 28px;
  line-height: 28px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}

.baseForm .el-row {
  display: flex;
  flex-wrap: wrap;
}

.baseForm ::v-deep .el-form-item--mini.el-form-item,
.baseForm ::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}

.baseForm ::v-deep .el-textarea__inner {
  width: 193px !important;
}

.baseForm ::v-deep .el-form-item__content {
  width: 193px !important;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 193px !important;
}
</style>